import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import TopPanel from "../toppanel.js";


module.exports = React.createClass({
    mixins: [LinkedStateMixin],

    getInitialState: function () {
        var today = new Date();
        var oneYearLater = new Date(today);
        oneYearLater.setYear(oneYearLater.getFullYear() + 3);
        var from = new Date(today);
        from.setMonth(0);
        from.setDate(1);

        var calendar = {};
        var years = [];
        var months = [];
        for (var i = HC_CONST.MIN_YEAR; i <= HC_CONST.MAX_YEAR; i++) {
            years.push(<option key={i} value={i}>{i}</option>);
            calendar[i] = {};
            for (var j = 1; j <= 12; j++) {
                calendar[i][j] = new Date(i, j, 0).getDate();
            }
        }
        for (var i = 1; i <= 12; i++)
            months.push(<option key={i} value={i}>{i}</option>);

        var days28 = [], days29 = [], days30 = [], days31 = [];
        for (var i = 1; i <= 31; i++) {
            if (i <= 28)
                days28.push(<option key={i} value={i}>{i}</option>)
            if (i <= 29)
                days29.push(<option key={i} value={i}>{i}</option>)
            if (i <= 30)
                days30.push(<option key={i} value={i}>{i}</option>)
            days31.push(<option key={i} value={i}>{i}</option>)
        }

        return {
            isPeriodChoosed: false,
            expires: oneYearLater,
            from: from,
            to: new Date(today),
            years: years,
            months: months,
            calendar: calendar,
            days28: days28,
            days29: days29,
            days30: days30,
            days31: days31,
            lastDays: '10',
            name: '',
            type: 1,
            afterFailState: false,
            reportTypes: {}
        }
    },

    componentDidMount: function () {
        HC_SubscribeHammerEvent(this.refs.panel, "swiperight", this.props.onGoBack);
    },
    componentWillUnmount: function () {
        HC_UnsubscribeHammerEvent(this.refs.panel, "swiperight");
    },

    periodClicked: function () {
        this.setState({
            isPeriodChoosed: true
        });
    },

    lastDaysClicked: function () {
        this.setState({
            isPeriodChoosed: false
        });
    },
    dateChanged: function (o) {
        var split = o.target.getAttribute('data-key').split('.');
        var date = this.state[split[0]];
        if (split[1] === 'day')
            date.setDate(parseInt(o.target.value));
        else if (split[1] === 'month')
            date.setMonth(parseInt(o.target.value) - 1);
        else if (split[1] === 'year')
            date.setFullYear(parseInt(o.target.value));
        this.setState({});
    },

    nameChanged: function(o) {
        this.setState({name: o.target.value});
    },
    lastDaysChanged: function(o) {
        var value = parseInt(o.target.value);
        if (value >= 0) {
            this.setState({lastDays: value});
        }
        if (o.target.value.trim().length === 0) {
            this.setState({lastDays: ''});
        }
    },

    getReportType: function(checklistId) {
        var id = checklistId.toString();
        if (this.state.reportTypes.hasOwnProperty(id)) {
            return this.state.reportTypes[id];
        }
        return "0";
    },

    setReportType: function(o) {
        var id = o.target.getAttribute("data-key").toString();
        this.state.reportTypes[id] = o.target.value;
        this.setState({reportTypes: this.state.reportTypes});
    },

    onSaveReport: function () {
        if (!HC_Validate()) {
            this.state.afterFailState = true;
            return;
        }

        var lastDays;
        if (!this.state.isPeriodChoosed)
            lastDays = parseInt($('#ReportLastDays').val());

        var newReport = {
            name: this.state.name,
            expires: this.state.expires.getTime()
        };
        newReport.items = this.props.checkedIds.map(function(o){
            return {checklist_id: parseInt(o), report_type: parseInt(this.getReportType(o))}
        }.bind(this));
        if (this.state.isPeriodChoosed) {
            newReport.to_date = this.state.to.getTime();
            newReport.days = (this.state.to.getTime() - this.state.from.getTime())/86400000 + 1;
        } else {
            newReport.days = lastDays;
        }
        if (this.props.onCreateReport)
            this.props.onCreateReport(newReport);
    },

    ensureGlobalValidationFunctionsCreated: function () {
        if (window.HC_REPORT_EDIT_VALIDATION != this) {
            window.HC_REPORT_EDIT_VALIDATION = this;

            window.HC_ReportEditValidation_Period = function(str) {
                if (!this.state.isPeriodChoosed) {
                    var lastDays = parseInt($('#ReportLastDays').val());
                    if (isNaN(lastDays) || lastDays <= 0)
                        return [false, ""];
                }
                return [true, ""];
            }.bind(this);
        }
    },

    goBackInternal: function () {
        if (HC_DeviceType() === HC_CONST.SCR_PHONE) {
            HC_RestoreRPanel();
        } else {
            this.props.onGoBack();
        }
    },

    render: function () {
        this.ensureGlobalValidationFunctionsCreated();

        var captionDivStyle = {display: "inline-block", marginRight: "2%"};
        captionDivStyle['flex'] = captionDivStyle['WebkitFlex'] = '0 1 9em';
        var labelStyle = {padding: "0.5%", display: "flex"};
        labelStyle['flexFlow'] = labelStyle['WebkitFlexFlow'] = 'row wrap';
        var div100 = {display: "inline-block", width: "80%", maxWidth: "350px"};
        div100['flex'] = div100['WebkitFlex'] = '1 1 200px';

        var input20 = {width: "28%", display: "inline"};
        var input40 = {width: "36%", display: "inline"};
        var input100 = {width: "100%", display: "inline"};

        var periodBox = "hc-green fa " + (this.state.isPeriodChoosed ? "fa-dot-circle-o" : "fa-circle-o");
        var lastdayBox = "hc-green fa " + (this.state.isPeriodChoosed ? "fa-circle-o hc-green" : "fa-dot-circle-o");

        var periodStyle = {
            fontSize: "1.5rem",
            marginRight: "0.5rem"
        };

        var content;
        if (!this.props.checkedIds || this.props.checkedIds.length === 0) {
            content = (
                <div ref="hc_reppanel"
                     style={{position:"absolute", top:"60px", bottom:"0", width:'100%', overflowX:"hidden", overflowY:"auto", WebkitOverflowScrolling:'touch', paddingBottom:'30px'}}>
                    <img src="/public/images/help-arrow.svg" width="142" height="144"
                         style={{marginTop:'80px', marginLeft:'30px'}}/>
                    <div className="hc-f4 hc-f-l" style={{marginTop:'30px', textAlign:'center'}}>{HC_LANG.REP_YCAN_SEL}</div>
                </div>
            );
        } else {
            var reportItems = this.props.checkedIds.map(function (id) {
                var item = HC_GetItemById(this.props.checklists, id);

                let optionItems = [];
                optionItems.push(<option value={HC_CONST.REPORT_OVERVIEW}>{HC_LANG.CHL_OVERVIEW}</option>);
                if (item.checklist_type == HC_CONST.CL_TYPE_REGULAR) {
                    optionItems.push(<option value={HC_CONST.REPORT_ERRORS}>{HC_LANG.CHL_ALL_ERR}</option>);
                    optionItems.push(<option value={HC_CONST.REPORT_NOT_FILLED}>{HC_LANG.CHL_TIME_FILLIND}</option>);
                    optionItems.push(<option value={HC_CONST.REPORT_ALL_INPUT}>{HC_LANG.CHL_ALL_INPUT}</option>);
                }

                return (<div key={id} className="hc-flex-display" style={labelStyle}>
                    <div style={captionDivStyle} className="hc-f3 hc-f-l">{item.name}</div>
                    <div style={div100}>
                        <select data-key={id} className="form-control hc-f4" style={input100} value={this.getReportType(id)} onChange={this.setReportType}>
                            {optionItems}
                        </select>
                    </div>
                </div>);
            }.bind(this));

            var period;
            if (this.state.isPeriodChoosed) {
                period = (<div style={{padding: "4% 5% 0%"}}>
                    <div className="hc-flex-display" style={labelStyle}>
                        <div style={captionDivStyle} className="hc-f3 hc-f-l">From</div>
                        <div style={div100}>
                            <select className="form-control hc-f4" data-key="from.day" onChange={this.dateChanged}
                                    value={this.state.from.getDate()} style={input40}>
                                {this.state['days' + this.state.calendar[this.state.from.getFullYear()][this.state.from.getMonth() + 1]]}
                            </select>
                            <select className="form-control hc-f4" data-key="from.month" onChange={this.dateChanged}
                                    value={this.state.from.getMonth()+1} style={input20}>
                                {this.state.months}
                            </select>
                            <select className="form-control hc-f4" data-key="from.year" onChange={this.dateChanged}
                                    value={this.state.from.getFullYear()} style={input40}>
                                {this.state.years}
                            </select>
                        </div>
                    </div>
                    <div className="hc-flex-display" style={labelStyle}>
                        <div style={captionDivStyle} className="hc-f3 hc-f-l">To</div>
                        <div style={div100}>
                            <select className="form-control hc-f4" data-key="to.day" onChange={this.dateChanged}
                                    value={this.state.to.getDate()} style={input40}>
                                {this.state['days' + this.state.calendar[this.state.to.getFullYear()][this.state.to.getMonth() + 1]]}
                            </select>
                            <select className="form-control hc-f4" data-key="to.month" onChange={this.dateChanged}
                                    value={this.state.to.getMonth()+1} style={input20}>
                                {this.state.months}
                            </select>
                            <select className="form-control hc-f4" data-key="to.year" onChange={this.dateChanged}
                                    value={this.state.to.getFullYear()} style={input40}>
                                {this.state.years}
                            </select>
                        </div>
                    </div>
                </div>);
            } else {
                period = (<div style={{padding: "4% 5% 0%"}}>
                    <div className="hc-flex-display" style={labelStyle}>
                        <div style={captionDivStyle} className="hc-f3 hc-f-l">Last days</div>
                        <div style={div100}>
                            <input  id="ReportLastDays" type="text" className="form-control hc-validated" value={this.state.lastDays} onChange={this.lastDaysChanged} data-vfunc="HC_ReportEditValidation_Period"/>
                        </div>
                    </div>
                </div>);
            }

            var ricon = "fa-floppy-o";
            var onRiconClick = this.onSaveReport;

            content = (
                <div ref="panel"
                     style={{position:"absolute", top:"60px", bottom:"0", width:'100%', overflowX:"hidden", overflowY:"auto", WebkitOverflowScrolling:'touch', paddingBottom:'30px'}}>
                    <div style={{padding: "4% 5% 5% "}}>
                        <div className="hc-flex-display" style={labelStyle}>
                            <div style={captionDivStyle} className="hc-f3 hc-f-l">Name</div>
                            <div style={div100}>
                                <input id="ReportName" type="text" className="form-control hc-validated" value={this.state.name} onChange={this.nameChanged}
                                        data-vfunc="HC_ValidateNotEmptyField"/>
                            </div>
                        </div>
                        <div style={{margin:'1rem'}}/>
                        {reportItems}
                        <div style={{margin:'1rem'}}/>
                        <div className="hc-flex-display" style={labelStyle}>
                            <div style={captionDivStyle} className="hc-f3 hc-f-l">Expires</div>
                            <div style={div100}>
                                <select className="form-control hc-f4" data-key="expires.day"
                                        onChange={this.dateChanged} value={this.state.expires.getDate()}
                                        style={input40}>
                                    {this.state['days' + this.state.calendar[this.state.expires.getFullYear()][this.state.expires.getMonth() + 1]]}
                                </select>
                                <select className="form-control hc-f4" data-key="expires.month"
                                        onChange={this.dateChanged} value={this.state.expires.getMonth()+1}
                                        style={input20}>
                                    {this.state.months}
                                </select>
                                <select className="form-control hc-f4" data-key="expires.year"
                                        onChange={this.dateChanged} value={this.state.expires.getFullYear()}
                                        style={input40}>
                                    {this.state.years}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div style={{paddingLeft: "5%", paddingRight: "5%"}}>
                        <div className="hc-f-l hc-flex-display" style={labelStyle}>
                            <div style={captionDivStyle} className="hc-f3"></div>
                            <div style={div100}>
                                <div onClick={this.lastDaysClicked} style={{display:'inline-block', cursor:'pointer', whiteSpace: "nowrap", marginRight:"1rem"}}>
                                    <i className={lastdayBox} style={periodStyle}></i>
                                    <lavel className="hc-f4">{HC_LANG.REP_LAST_DAYS}</lavel>
                                </div>
                                <div onClick={this.periodClicked} style={{display:'inline-block', cursor:'pointer', whiteSpace: "nowrap"}}>
                                     <i className={periodBox} style={periodStyle}></i>
                                    <lavel className="hc-f4">{HC_LANG.REP_FOR_PERIOD}</lavel>
                                </div>
                            </div>
                        </div>
                    </div>
                    {period}
                </div>
            );
        }

        return (
            <div className="hc-internal-panel">
                <TopPanel text={HC_LANG.REP_CRE_REP} licon="fa-angle-left" onLiconClick={this.goBackInternal}
                    ricon={ricon} onRiconClick={onRiconClick} />
                {content}
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./reports/ReportEdit.js